import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';

/** Representa o Filter da entidade Mercado */
export class MercadoFilter implements Filter {
    filterPsq: string;
    situacao: number;
    situacoes: number[] = [];

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }
        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }
        this.situacoes?.forEach(situacao => params = params.append('situacao', situacao.toString()));

        return params;
    }

    clear() {
        this.filterPsq = null;
        this.situacao = null;
    }
}

